module.exports = __webpack_public_path__ + "static/media/LogoRectangle.fdb9ca68.png";